import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AdminRoute = ({ children }) => {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  // always navigate to tasks if user is not admin
  if (!isAdmin) return navigate("/tasks");

  return children;
};

export default AdminRoute;
